import { ApiError, ApiErrorSpecies } from '../types'

export const getMessageFromApiError = (error: ApiError): string => {
  const traceId = error.traceId
  const detail = error.specie === ApiErrorSpecies.Single ? error.detail : error.errors[0]?.detail

  const formattedError = `${detail.endsWith('.') ? detail : detail + '.'} ID: ${traceId}`

  return formattedError
}
